import * as React from "react";
import ThemeEditorRow from "./ThemeEditorRow";
const themeMap = {
  general: [
    {
      key: "primary",
      name: "Brand",
      type: "brand"
    },
    {
      key: "background",
      name: "Body Background",
      type: "global"
    },
    {
      key: "contentBackground",
      name: "Content Background",
      type: "global"
    },
    {
      key: "link",
      name: "Links",
      type: "global"
    },
    {
      key: "tertiary",
      name: "Text",
      type: "brand"
    },
    {
      key: "secondary",
      name: "Text Inverse",
      type: "brand"
    }
  ],
  variant: [
    {
      key: "default",
      name: "Default",
      type: "variant"
    },
    {
      key: "danger",
      name: "Error",
      type: "variant"
    },
    {
      key: "info",
      name: "Informative",
      type: "variant"
    },
    {
      key: "primary",
      name: "Primary",
      type: "variant"
    },
    {
      key: "success",
      name: "Success",
      type: "variant"
    },
    {
      key: "warning",
      name: "Warning",
      type: "variant"
    },
    {
      key: "gray",
      name: "Gray",
      type: "variant"
    }
  ]
};
const ThemeSection = ({ currentThemeColors, onChange, section }) => themeMap[section].map(({ key, name, type }) => /* @__PURE__ */ React.createElement(
  ThemeEditorRow,
  {
    colorName: name,
    key: name,
    currentThemeColors,
    onChange,
    colorKey: key,
    colorType: type
  }
));
export default ThemeSection;
